import { menuThirds } from 'constants/menus'
import TreatmentTemplate from 'features/setting/template/treatment-template'
import TreatmentTemplateForm from 'features/setting/template/treatment-template-form'
import TreatmentTemplateTypes from "features/setting/treatment-template-types/treatment-template-types"

const routeTemplateTypes = [
    {
        ...menuThirds.TREATMENT_TEMPLATE_TYPE,
        component: TreatmentTemplateTypes,
        appBar: true
    },
    {
        ...menuThirds.TREATMENT_TEMPLATE,
        component: TreatmentTemplate,
        appBar: true
    },
    {
        name: menuThirds.TREATMENT_TEMPLATE.name,
        key: menuThirds.TREATMENT_TEMPLATE.key,
        textName: 'เพิ่มเทมเพลต',
        active: false,
        path: menuThirds.TREATMENT_TEMPLATE.path + '/create',
        component: TreatmentTemplateForm,
        appBar: true
    },
    {
        name: menuThirds.TREATMENT_TEMPLATE.name,
        key: menuThirds.TREATMENT_TEMPLATE.key,
        textName: 'แก้ไขเทมเพลต',
        active: false,
        path: menuThirds.TREATMENT_TEMPLATE.path + '/update',
        component: TreatmentTemplateForm,
        appBar: true
    },
    {
        name: menuThirds.TREATMENT_TEMPLATE.name,
        key: menuThirds.TREATMENT_TEMPLATE.key,
        textName: 'แก้ไขเทมเพลต',
        active: false,
        path: menuThirds.TREATMENT_TEMPLATE.path + '/view',
        component: TreatmentTemplateForm,
        appBar: true
    },
]

export default routeTemplateTypes